import { FC, Fragment, useContext } from "react";
import { UserProgramContext } from "../../context/user-program/user-program";
import { Navigate, useLocation } from "react-router-dom";
import {
  ROUTE_HOME,
  SUBROUTE_SIGN_IN,
  SUBROUTE_PATIENTS,
  SUBROUTE_CLINIC_WEIGHT,
  SUBROUTE_CLINIC_HOME,
} from "../../constants";

type Props = {
  children: React.ReactNode;
};

const SIGN_IN_ROUTE = `${ROUTE_HOME}${SUBROUTE_SIGN_IN}`;

export const ProtectedRoute: FC<Props> = ({ children }) => {
  const { unauthorized, role } = useContext(UserProgramContext);

  const location = useLocation();

  if (unauthorized && location.pathname !== SIGN_IN_ROUTE) {
    return <Navigate to={SIGN_IN_ROUTE} replace={true} />;
  }

  if (role === "employee") {
    return <Navigate to={SUBROUTE_PATIENTS} replace={true} />;
  }

  if (role === "clinic-weight") {
    return <Navigate to={SUBROUTE_CLINIC_WEIGHT} replace={true} />;
  }

  if (role === "clinic-dashboard") {
    return <Navigate to={SUBROUTE_CLINIC_HOME} replace={true} />;
  }

  return <Fragment>{children}</Fragment>;
};
